import {
  useRecordContext,
  Button,
  useDataProvider,
  useNotify,
  useRefresh,
  TextInput,
  DateInput,
  required,
  ArrayInput,
  SimpleFormIterator,
  SelectInput,
  FormDataConsumer,
} from "react-admin";
import DoneIcon from "@mui/icons-material/Done";
import { RankingStatus } from "utils/constants";
import { candidateRequests } from "api/candidateApi";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import React from "react";
import FormModal from "server/components/Modals/FormModal";

const ApproveRankingButton = ({ specialities }) => {
  const REINSTATING_RIGHTS_ID = 0; // "Възстановяващи права"

  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const dataProvider = useDataProvider();

  const status = record?.status;

  if (!record || !specialities) {
    return null;
  }

  // No try/catch: FormModal notifies on error and stays open.
  const approveDraft = async ({ specialityOrders }) => {
    await dataProvider.create(candidateRequests.approveCampaignRanking(record.id), { data: { specialityOrders } });
    notify("Успешно одобрено класиране", { type: "success" });
    refresh();
  };

  var specialityIds = record.specialityRankings.map(x => x.specialityId);
  specialityIds.sort((a, b) => {
    if (a === REINSTATING_RIGHTS_ID) return 1;
    if (b === REINSTATING_RIGHTS_ID) return -1;
    return a - b;
  });

  return (
    <SecuredComponent permission={permissions.canManageCampaignRankings}>
      <FormModal
        triggerButton={
          <Button
            label="Одобряване"
            variant="contained"
            size="medium"
            sx={{ display: status === RankingStatus.Draft ? "flex" : "none" }}
          >
            <DoneIcon />
          </Button>
        }
        titleContent="Одобряване на класиране"
        onConfirm={approveDraft}
        saveTitle="Одобри"
        saveIcon={<DoneIcon />}
        closeTitle="Затвори"
        dialogSize="md"
      >
        <ArrayInput
          source="specialityOrders"
          label="Заповеди"
          defaultValue={specialityIds?.map(id => ({
            specialityId: id,
          }))}
          validate={required()}
        >
          <SimpleFormIterator
            disableAdd
            disableRemove
            disableReordering
            disableClear
            inline
            sx={{
              "& .RaSimpleFormIterator-line": {
                paddingY: 1,
                paddingX: 2,
                marginBottom: 3,
              },
            }}
          >
            <SelectInput
              source="specialityId"
              label="Специалност"
              readOnly
              fullWidth
              helperText={false}
              choices={[{ id: REINSTATING_RIGHTS_ID, name: "Възстановяващи права" }, ...specialities]}
              sx={{ minWidth: 350 }}
            />
            <FormDataConsumer>
              {({ scopedFormData }) => (
                <>
                  <DateInput
                    source="orderDate"
                    label="Дата на заповед"
                    validate={scopedFormData.specialityId !== REINSTATING_RIGHTS_ID && required()}
                    helperText={false}
                  />
                  <TextInput
                    source="orderNumber"
                    label="Номер на заповед"
                    validate={scopedFormData.specialityId !== REINSTATING_RIGHTS_ID && required()}
                    helperText={false}
                  />
                </>
              )}
            </FormDataConsumer>
          </SimpleFormIterator>
        </ArrayInput>
      </FormModal>
    </SecuredComponent>
  );
};

export default ApproveRankingButton;
